import { API } from "../../apiSlice";

export const getLoanApplicationsApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getLoanApplications: builder.query({
      query: (id) => {
        return {
          url: `users/user-loan-requests`,
        };
      },
    }),
  }),
});

export const { useGetLoanApplicationsQuery } = getLoanApplicationsApiSlice;
